export interface WebHostingAiDraft {
  html: string;
  fileName: string;
  prompt: string;
  createdAt: number;
}

export const WEB_HOSTING_AI_DRAFT_KEY = 'img-cloud:web-hosting-ai:draft';

const isDraft = (value: unknown): value is WebHostingAiDraft => {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const candidate = value as Partial<WebHostingAiDraft>;
  return typeof candidate.html === 'string'
    && candidate.html.trim().length > 0
    && typeof candidate.fileName === 'string'
    && typeof candidate.prompt === 'string'
    && typeof candidate.createdAt === 'number';
};

export const getWebHostingAiDraft = (): WebHostingAiDraft | null => {
  try {
    const raw = window.sessionStorage.getItem(WEB_HOSTING_AI_DRAFT_KEY);
    if (!raw) {
      return null;
    }
    const parsed: unknown = JSON.parse(raw);
    if (!isDraft(parsed)) {
      window.sessionStorage.removeItem(WEB_HOSTING_AI_DRAFT_KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const saveWebHostingAiDraft = (draft: WebHostingAiDraft): void => {
  if (!isDraft(draft)) {
    throw new Error('Invalid web-hosting AI draft');
  }
  window.sessionStorage.setItem(WEB_HOSTING_AI_DRAFT_KEY, JSON.stringify(draft));
};

export const clearWebHostingAiDraft = (): void => {
  try {
    window.sessionStorage.removeItem(WEB_HOSTING_AI_DRAFT_KEY);
  } catch {
    // Storage cleanup is best effort.
  }
};
